import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { type GetAllBannerSetsQueryParams, getAllBannerSets } from '.';
import { get_all_banner_sets_query_key } from './query-key';
export const useGetAllBannerSets = t0 => {
  const $ = _c(19);
  const {
    active,
    id,
    name,
    page: t1,
    pageUrl,
    quantity: t2,
    routeId
  } = t0;
  const page = t1 === undefined ? 1 : t1;
  const quantity = t2 === undefined ? 5 : t2;
  let t3;
  if ($[0] !== active || $[1] !== id || $[2] !== name || $[3] !== page || $[4] !== pageUrl || $[5] !== quantity || $[6] !== routeId) {
    t3 = get_all_banner_sets_query_key({
      active,
      id,
      name,
      page,
      pageUrl,
      quantity,
      routeId
    });
    $[0] = active;
    $[1] = id;
    $[2] = name;
    $[3] = page;
    $[4] = pageUrl;
    $[5] = quantity;
    $[6] = routeId;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== active || $[9] !== id || $[10] !== name || $[11] !== page || $[12] !== pageUrl || $[13] !== quantity || $[14] !== routeId) {
    t4 = async () => await getAllBannerSets({
      active,
      id,
      name,
      page,
      pageUrl,
      quantity,
      routeId
    });
    $[8] = active;
    $[9] = id;
    $[10] = name;
    $[11] = page;
    $[12] = pageUrl;
    $[13] = quantity;
    $[14] = routeId;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== t3 || $[17] !== t4) {
    t5 = {
      queryKey: t3,
      queryFn: t4
    };
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return useQuery(t5);
};